import React, { useState } from 'react';
import { weekStartsOn } from '../utils/timeFormat';
import {
  format, startOfMonth, endOfMonth, startOfWeek, endOfWeek,
  eachDayOfInterval, isToday, isSameMonth,
} from 'date-fns';
import { a11y } from '../utils/a11yLabels';

function MiniMonth({ year, monthIndex, locale, onSelectDate, selectedDate }) {
  const monthDate    = new Date(year, monthIndex, 1);
  const isThisMonth  = monthDate.getMonth() === new Date().getMonth() && monthDate.getFullYear() === new Date().getFullYear();
  const calStart     = startOfWeek(startOfMonth(monthDate), { weekStartsOn: weekStartsOn() });
  const calEnd       = endOfWeek(endOfMonth(monthDate),     { weekStartsOn: weekStartsOn() });
  const days         = eachDayOfInterval({ start: calStart, end: calEnd });
  return (
    <div style={{ padding: '4px 2px' }}>
      <div style={{
        textAlign: 'center', fontSize: '0.68rem', fontWeight: 700,
        marginBottom: 4, textTransform: 'capitalize',
        color: isThisMonth ? 'var(--color-primary)' : 'var(--color-text-muted)',
      }}>
        {format(monthDate, 'MMM', { locale })}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(7, 1fr)', rowGap: 1 }}>
        {days.map(day => {
          const inMonth  = isSameMonth(day, monthDate);
          // FIX: only show today circle when the day is actually in this month
          const todayDay = isToday(day) && inMonth;
          return (
            <div
              key={day.toString()}
              onClick={() => inMonth && onSelectDate(format(day, 'yyyy-MM-dd'))}
              style={{
                textAlign: 'center',
                fontSize: '0.57rem',
                lineHeight: '13px',
                height: 15,
                borderRadius: '50%',
                cursor: inMonth ? 'pointer' : 'default',
                fontWeight: todayDay ? 700 : 400,
                // Today: outline ring (not filled) — softer, like iOS Calendar
                background: 'transparent',
                border: todayDay ? '1.5px solid var(--color-primary)' : 'none',
                color: todayDay ? 'var(--color-primary)' : inMonth ? 'var(--color-text)' : 'transparent',
                boxSizing: 'border-box',
              }}
            >
              {inMonth ? format(day, 'd') : ''}
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default function YearView({ onSelectDate, selectedDate, locale }) {
  const [year, setYear] = useState(new Date().getFullYear());
  // No user here — the date-fns locale carries the language tag we need.
  const A = a11y(locale?.code);

  return (
    <div className="card" style={{ minHeight: 'calc(100dvh - 143px)', overflow: 'hidden' }}>
      {/* Header */}
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12 }}>
        <button className="date-nav-btn" aria-label={A.prevYear} onClick={() => setYear(y => y - 1)}>‹</button>
        <span style={{ fontWeight: 700, fontSize: '1rem' }}>{year}</span>
        <button className="date-nav-btn" aria-label={A.nextYear} onClick={() => setYear(y => y + 1)}>›</button>
      </div>

      {/* 3-column grid of 12 mini months */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 10 }}>
        {Array.from({ length: 12 }, (_, i) => (
          <MiniMonth
            key={i}
            year={year}
            monthIndex={i}
            locale={locale}
            onSelectDate={onSelectDate}
            selectedDate={selectedDate}
          />
        ))}
      </div>
    </div>
  );
}
